import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  renewalData: [],
  renewalDetailData: {},
  renewalTitles: {},
};

const renewalSlice = createSlice({
  name: "renewal",
  initialState: initialState,
  reducers: {
    setRenewalData: (state, action) => {
      state.renewalData = action.payload;
    },
    setRenewalDetailData: (state, action) => {
      state.renewalDetailData = action.payload;
    },
    setRenewalTitles: (state, action) => {
      state.renewalTitles = action.payload;
    },
  },
});
export const { setRenewalData, setRenewalDetailData, setRenewalTitles } =
  renewalSlice.actions;

export default renewalSlice.reducer;
